import { render } from "./IconRequired.vue?vue&type=template&id=11309f27&scoped=true&ts=true"
import script from "./IconRequired.vue?vue&type=script&lang=ts"
export * from "./IconRequired.vue?vue&type=script&lang=ts"

import "./IconRequired.vue?vue&type=style&index=0&id=11309f27&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11309f27"]])

export default __exports__